import { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { DataPlanDetailView } from "./component";
import { Product } from "../../../../components/Reusable/type";
import { fetchDataPlans } from "../../../../features/auth/store/dataPlanSlice";
import { AppDispatch, RootState } from "../../../../redux/store";
import DataPlans from "./DataPlan";
import { fetchDataCategories } from "../../../../features/auth/store/dataCategorySlice";
import { SortBy, SortOrder } from "../../../../features/auth/store/types/types";
import { fetchCountries } from "../../../../features/auth/store/countrySlice";

const DataPlanRouter: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [statusFilter, setStatusFilter] = useState<string>("");
  const [categoryFilter, setCategoryFilter] = useState<string>("");
  const [countryFilter, setCountryFilter] = useState<string>("");
  const [sortBy, setSortBy] = useState<SortBy | "">("created_at");
  const [sortOrder, setSortOrder] = useState<SortOrder | "">("desc");
  const [selectedDataPlan, setSelectedDataPlan] = useState<Product | null>(
    null,
  );
  const [showDetailView, setShowDetailView] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>("");

  const { dataPlans, loading, error } = useSelector(
    (state: RootState) => state.dataPlans,
  );

  const { dataCategories } = useSelector(
    (state: RootState) => state.dataCategories,
  );

  const isMounted = useRef(false);

  useEffect(() => {
    if (!dataCategories || dataCategories.length == 0) {
      dispatch(fetchDataCategories({ perPage: 100 }));
    }
    dispatch(fetchCountries({ page: 1, perPage: 100 }));
  }, []);

  useEffect(() => {
    if (!isMounted.current) {
      isMounted.current = true;
      dispatch(fetchDataPlans({}));
      return;
    }
    const handler = setTimeout(() => {
      const filters: Record<string, any> = {};

      if (statusFilter) filters.status = statusFilter;
      if (categoryFilter) filters.category = categoryFilter; // ID sent
      if (countryFilter) filters.country = countryFilter; // ID sent
      if (sortBy) filters.sort_by = sortBy;
      if (sortOrder) filters.sort_order = sortOrder;
      if (searchTerm.trim()) filters.search = searchTerm.trim();

      dispatch(fetchDataPlans(filters));
    }, 350);

    return () => clearTimeout(handler);
  }, [
    dispatch,
    statusFilter,
    categoryFilter,
    countryFilter,
    sortBy,
    sortOrder,
    searchTerm,
  ]);

  // Transform DataPlan to Product - ensuring all required fields are present

  const handleDataPlanClick = (dataPlan: Product) => {
    setSelectedDataPlan(dataPlan);
    setShowDetailView(true);
  };

  const handleBackToList = () => {
    setShowDetailView(false);
    setSelectedDataPlan(null);
  };

  if (showDetailView && selectedDataPlan) {
    return (
      // <ProductDetailView dataPlan={selectedDataPlan} onBack={handleBackToList} />
      <DataPlanDetailView
        dataPlan={{
          ...selectedDataPlan,
        }}
        onBack={handleBackToList}
      />
    );
  }

  return (
    <DataPlans
      dataPlans={dataPlans || []}
      loading={loading}
      error={error}
      seerchTerm={searchTerm}
      statusFilter={statusFilter}
      setStatusFilter={setStatusFilter}
      onDataPlanClick={handleDataPlanClick}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      categoryFilter={categoryFilter}
      setCategoryFilter={setCategoryFilter}
      countryFilter={countryFilter}
      setCountryFilter={setCountryFilter}
      sortBy={sortBy}
      setSortBy={setSortBy}
      sortOrder={sortOrder}
      setSortOrder={setSortOrder}
    />
  );
};

export default DataPlanRouter;
